<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title">Facturenpagina</h4>
      <div class="row p-0 m-0">
        <div class="col-lg-3 col-md-4 mt-2 ">
          <FilterInvoice @filterStatusChanged="filterStatusChanged" :invoiceStatussen="invoiceStatussen" :isAdmin="isAdmin"/>
        </div>
        <div class="col-lg-9 col-md-8">
          <SearchOrder
              :searchQuery="searchQuery"
              placeholder="Zoeken op klantnaam, referentie, bedrag, factuurdatum, verkooporder, referentie, factuurnummer"
              @performSearch="performSearch"
          />
          <div class="table-responsive">
            <table class="table caption-top table-striped border table-hover">
              <caption>Lijst met facturen</caption>
              <thead>
              <tr>
                <th scope="col" @click="sort('status')" :class="sortClass('status')">&nbsp;</th>
                <th scope="col" @click="sort('updated_at')" :class="sortClass('updated_at')" class="text-center">
                  Verwerkt
                </th>
                <th scope="col" @click="sort('customer')" :class="sortClass('customer')">Klant</th>
                <th scope="col" @click="sort('amount')" :class="sortClass('amount')" class="text-end">Bedrag</th>
                <th scope="col" @click="sort('date')" :class="sortClass('date')" class="text-center">Fact.datum</th>
                <th scope="col" @click="sort('number')" :class="sortClass('number')">Verkoopord.</th>
                <th scope="col" @click="sort('ref')" :class="sortClass('date')">Reference</th>
                <th scope="col" @click="sort('number')" :class="sortClass('number')">Fact.nummer</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(invoice, index) in filteredInvoices" :key="index" class="clickable-row"
                  @click="goToInvoiceDetailPage(index)">
                <td><i class="bi bi-circle-fill close" :class="getColor(invoice.status)"></i></td>
                <td class="text-center">{{ getDateTime(invoice.updated_at) }}</td>
                <td>{{ invoice.customer?.name }}</td>
                <td class="text-end">{{ getAmount(invoice.amount) }}</td>
                <td class="text-center">{{ getDate(invoice.date) }}</td>
                <td>{{ invoice.verkooporder }}</td>
                <td>{{ invoice.reference }}</td>
                <td>{{ invoice.number }}</td>
              </tr>
              </tbody>
            </table>
            <div ref="sentinel"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceFactory from "../services/ServiceFactory"
import FilterInvoice from "../components/FilterInvoice.vue"
import Utils from "../utils/Utils"
import SearchOrder from "@/components/SearchOrder.vue";
import fetchInvoicesAction from "@/services/FetchInvoicesAction.js";
import NavigationService from "@/services/NavigationService.js";

export default {
  name: 'InvoicesPage',
  props: ['user', 'isAdmin'],
  components: {SearchOrder, FilterInvoice},
  data() {
    return {
      invoiceService: null,
      invoices: [],
      invoiceStatussen: [],
      filteredInvoices: [],
      currentSort: 'updated_at',
      currentSortDir: 'desc',
      searchQuery: '',
      searchDataStart: '',
      searchDataEnd: '',
      searchCustomers: '',
      amountMin: null,
      amountMax: null,
      invoiceDateStart: '',
      invoiceDateEnd: '',
      webSocketService: null,
      page: 1,
      prevPage: 0,
      pageSize: 25,
      observer: null,
      currentFilter: null
    }
  },
  watch: {
    user: {
      handler: function (val) {
        if (val) {
          this.loadInvoices()
          this.loadInvoiceStatussen()
        }
      },
      deep: true
    }
  },
  methods: {
    performSearch(query) {
      this.searchQuery = query;
      this.page = 1;
      this.prevPage = 0;
      this.loadInvoicesForSearch();
      this.prevPage = this.page;
      this.page += 1;
    },
    async loadInvoicesForSearch() {
      const newInvoices = await this.loadInvoiceList();
      if (!newInvoices) return;
      this.invoices = newInvoices
      this.filteredInvoices = newInvoices;
    },
    async loadInvoiceList() {
      const newOrders = await fetchInvoicesAction.getInvoices(
          this.page,
          this.pageSize,
          this.currentSort,
          this.currentSortDir,
          this.searchQuery,
          this.searchDataStart,
          this.searchDataEnd,
          this.searchStatus,
          this.searchCustomers,
          this.invoiceDateStart,
          this.invoiceDateEnd,
          this.amountMin,
          this.amountMax,
      );
      if (!newOrders) return;

      return [...newOrders]
    },
    getColor(status) {
      return Utils.getColorForInvoiceStatus(status)
    },
    sort(sortBy) {
      if (sortBy === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort = sortBy;
      }
      this.performSearch(this.searchQuery);
    },
    sortClass(column) {
      return {
        'sort-asc': this.currentSort === column && this.currentSortDir === 'asc',
        'sort-desc': this.currentSort === column && this.currentSortDir === 'desc'
      };
    },
    filterStatusChanged(filterObj) {
      let statuses = [];
      if (filterObj.status && typeof filterObj.status === 'object' && !Array.isArray(filterObj.status)) {
        statuses = Object.entries(filterObj.status)
            .filter(([, value]) => value === true)
            .map(([key]) => Number(key));
      }
      this.searchStatus = statuses.join(',')
      this.searchDataStart = filterObj.startDate;
      this.searchDataEnd = filterObj.endDate;
      this.invoiceDateStart = filterObj.invoiceDateStart;
      this.invoiceDateEnd = filterObj.invoiceDateEnd;
      this.amountMin = filterObj.amountMin;
      this.amountMax = filterObj.amountMax;

      let customers = [];
      if (filterObj.customer && typeof filterObj.customer === 'object' && !Array.isArray(filterObj.customer)) {
        customers = Object.entries(filterObj.customer)
            .filter(([, value]) => value === true)
            .map(([key]) => String(key));
      }
      this.searchCustomers = customers.join(',');
      this.currentFilter = filterObj;

      this.performSearch(this.searchQuery);

    },
    getDateTime(isoString) {
      return Utils.formatDateTimeString(isoString)
    },
    getDate(isoString) {
      return Utils.formatDateString(isoString)
    },
    getAmount(amount) {
      return Utils.formatCurrency(amount)
    },
    goToInvoiceDetailPage(index) {
      // Sla de huidige lijst met gefilterde facturen en de navigatiestatus op
      NavigationService.saveItems(
        this.filteredInvoices, 
        {
          searchQuery: this.searchQuery,
          currentSort: this.currentSort,
          currentSortDir: this.currentSortDir,
          searchDataStart: this.searchDataStart,
          searchDataEnd: this.searchDataEnd,
          searchCustomers: this.searchCustomers,
          amountMin: this.amountMin,
          amountMax: this.amountMax,
          invoiceDateStart: this.invoiceDateStart,
          invoiceDateEnd: this.invoiceDateEnd
        },
        'invoice', // itemType
        '/invoices'  // listRouteName
      );
      
      // Sla de huidige index op
      NavigationService.setCurrentIndex(index, 'invoice');
      
      // Navigeer naar de detailpagina
      this.$router.push({name: 'InvoiceDetail', params: {id: this.filteredInvoices[index].id}});
    },
    async loadInvoiceStatussen() {
      this.invoiceStatussen = await this.invoiceService.getInvoiceStatussen();
    },
    async loadInvoices() {
      //prevent double loading of the same page
      if (this.prevPage === this.page) return;
      this.prevPage = this.page;

      const newInvoices = await this.loadInvoiceList();
      if (!newInvoices) return;

      this.invoices = [...this.invoices, ...newInvoices];
      this.filteredInvoices = this.invoices;
      this.page += 1;
    },
    observeSentinel() {
      // Controleer eerst of de sentinel ref bestaat
      if (!this.$refs.sentinel) {
        console.log('Sentinel element niet gevonden, observer niet geïnitialiseerd');
        return;
      }

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 1.0
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadInvoices();
          }
        });
      }, options);

      this.observer.observe(this.$refs.sentinel);
    },
  },
  async mounted() {
    this.invoiceService = ServiceFactory.getService('InvoiceService')
    this.invoiceService.addEventListener('getInvoicesFailed', () => {
      this.$emit('showToast', ['Fout bij ophalen facturen', 'bg-danger'])
    })
    if (this.user) {
      // Zorgen dat eventuele cache wordt geleegd bij (her)laden van de pagina
      if (fetchInvoicesAction) {
        fetchInvoicesAction.clearCache();
      }
      
      await this.loadInvoices()
      await this.loadInvoiceStatussen()
      this.webSocketService = ServiceFactory.getService('WebSocketService')

      this.webSocketService.addEventListener('invoicesUpdated', (event) => {
        // Nieuwe facturen ontvangen via WebSocket
        this.invoices = event.detail;
        this.invoices.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        
        // Cache leegmaken zodat bij terugkeer naar InvoicesPage de nieuwe facturen worden opgehaald
        if (fetchInvoicesAction) {
          fetchInvoicesAction.clearCache();
        }
        
        // Filters correct toepassen op de nieuwe data
        this.$nextTick(() => {
          if (this.currentFilter) {
            this.filterStatusChanged(this.currentFilter);
          } else {
            this.filteredInvoices = this.invoices;
          }
        });
      });
      this.webSocketService.connect()
    }
    this.observeSentinel();
  },
  beforeUnmount() {
    // Cleanup IntersectionObserver
    if (this.observer) {
      this.observer.disconnect();
    }
    
    // Cleanup WebSocket event listeners
    if (this.webSocketService) {
      this.webSocketService.removeEventListener('invoicesUpdated');
    }
  }
}
</script>

<style scoped>
.card {
  border: none;
}

th {
  cursor: pointer;
}

.sort-asc::after {
  content: ' ▲';
}

.sort-desc::after {
  content: ' ▼';
}
</style>